import type { PlaybookCondition } from "@repo/app-types/entities/filterConditions";
import type {
  PlaybookId,
  PlaybookNode,
} from "@repo/app-types/entities/playbook";
import { assertUnreachable } from "@repo/app-types/helpers/utilities";
import type { FC } from "react";
import { PlaybookScoreCriterionConditionMenu } from "./playbookScoreCriterionConditionMenu.js";
import { PlaybookSectionCriterionMenu } from "./playbookSectionCriterionMenu.js";
import { PlaybookYesNoCriterionConditionMenu } from "./playbookYesNoCriterionConditionMenu.js";

export interface PlaybookConditionMenuProps {
  playbookId: PlaybookId;
  node: PlaybookNode;
  onSelect: (condition: PlaybookCondition) => void;
}

export const PlaybookConditionMenu: FC<PlaybookConditionMenuProps> = (
  props,
) => {
  const node = props.node;

  if (node.type === "section") {
    return (
      <PlaybookSectionCriterionMenu
        playbookId={props.playbookId}
        sectionId={node.id}
        onSelect={props.onSelect}
      />
    );
  }

  if (node.type === "criteria") {
    if (node.grading_value_type === "yes_no") {
      return (
        <PlaybookYesNoCriterionConditionMenu
          playbookId={props.playbookId}
          criterionId={node.id}
          onSelect={props.onSelect}
        />
      );
    }

    if (node.grading_value_type === "1_5_score") {
      return (
        <PlaybookScoreCriterionConditionMenu
          playbookId={props.playbookId}
          criterionId={node.id}
          onSelect={props.onSelect}
        />
      );
    }

    return assertUnreachable(node.grading_value_type, () => null);
  }

  return assertUnreachable(node, () => null);
};
